import { gql } from "@apollo/client"
import { RESPONSE_TEMPERATURE_TIMER_FIELDS } from "../../../processes/fragments/responseTemperatureTimerFragment"

const TEMPERATURE_TIMER_JOB_STEP_FIELDS = gql`
  fragment TemperatureTimerJobStepFields on TemperatureTimerJobStep {
    id
    step
    number
    section
    name
    description
    responseType
    responseMandatory
    responseSensors
    responseTemperatureTimer {
      ...ResponseTemperatureTimerFields
    }
    startedAt
    stoppedAt
    compactResponseSelections {
      ...CompactResponseSelectionFields
    }
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
    repeatable
  }
  ${RESPONSE_TEMPERATURE_TIMER_FIELDS}
`

export { TEMPERATURE_TIMER_JOB_STEP_FIELDS }
